var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['lm-col', `lm-col_${ _vm.spanClass }`],style:({
    'padding-right': _vm.gutter,
    'padding-left': _vm.gutter
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }